module.exports = __webpack_public_path__ + "static/img/h5btn.798c323.gif";


//////////////////
// WEBPACK FOOTER
// ./static/image/matching/h5btn.gif
// module id = 0et6
// module chunks = 119